export default {"src":"/_next/static/media/Arrow-Right-Blue.84d43ba8.svg","height":24,"width":24};